/* eslint-disable prefer-promise-reject-errors */
import { axios } from '@carvana/purchase-utils';

export const getNotarizeStatus = () =>
axios({
  method: 'get',
  url: `${process.env.API_URL}/api/v1/notarize`
}).then(res => res.data);
